import { useMemo } from "react";

import { match } from "ts-pattern";

import { GalaxyTheme } from "../theme/constants";
import { useGalaxyTheme } from "../theme/GalaxyTheme";

import GalaxyLogomarkDark from "../assets/components/GalaxyLogomarkDark";
import GalaxyLogomarkLight from "../assets/components/GalaxyLogomarkLight";

const GalaxyLogomark = ({ height, isDark }: { height: number; isDark?: boolean }) => {
  const { galaxyTheme } = useGalaxyTheme();

  const logo = useMemo(() => {
    if (isDark) {
      return <GalaxyLogomarkDark height={height} />;
    }
    return match(galaxyTheme)
      .with(GalaxyTheme.DARK, () => <GalaxyLogomarkLight height={height} />)
      .with(GalaxyTheme.LIGHT, () => <GalaxyLogomarkDark height={height} />)
      .exhaustive();
  }, [height, isDark, galaxyTheme]);

  return logo;
};

export default GalaxyLogomark;
